export default __webpack_public_path__ + "static/media/14.68407ce0.jpg";